import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller<HTMLElement> {
  static targets = ["dropdown"]

  declare readonly dropdownTarget: HTMLElement
  overlay!: HTMLElement

  connect(): void {
    this.overlay = document.querySelector(".modal-overlay") as HTMLElement
    useClickOutside(this, {
      element: this.dropdownTarget,
    })

    this.open()
  }

  clickOutside(_event: Event): void {
    this.hideDropdown()
    this.hideOverlay()
    this.dispatchScrollEvent(false)
  }

  dispatchScrollEvent(disable: boolean): void {
    const event = new CustomEvent("scroll:toggle", {
      detail: { disable },
      bubbles: true,
    })

    document.body.dispatchEvent(event)
  }

  open(): void {
    if (document.body.dataset.isMobile === "true") {
      this.dispatchScrollEvent(true)
      this.dropdownTarget.scrollTop = 0
      this.showOverlay()
    }
  }

  hideDropdown(): void {
    this.dropdownTarget.classList.add("hidden")
  }

  hideOverlay(): void {
    this.overlay.classList.remove("modal-overlay-on")
  }

  showOverlay(): void {
    this.overlay.classList.add("modal-overlay-on")
  }
}
